'use strict';

export function icitFadingPanels() {
    const panels = gsap.utils.toArray(".panels .panel");
    const container = document.querySelector(".panels");

    if (!panels.length || !container) {
        console.warn("Fading panels or container not found.");
        return;
    }

    panels.forEach((panel, i) => {
        gsap.to(panel, {
            scrollTrigger: {
                trigger: panel,
                start: () => "top " + panels[i - 1]?.clientHeight ?? 0+ "px",
                end: "bottom center",
                scrub: true,
                onUpdate: self => {
                    if ( 0 === i ) return;
                    const progress = self.progress;

                    gsap.to(panels[i-1]?.querySelector('.panel-content'), {
                        opacity: Math.max(1 - progress, 0),
                    });
                    for ( const animation of panels[i-1]?.querySelectorAll('.panel-animation') ) {
                        gsap.to(animation, {
                            opacity: Math.max(1 - progress, 0),
                        });
                    }
                    gsap.to(panels[i-1]?.querySelector('.panel-header'), {
                        opacity: Math.max(1 - progress, 0),
                    });
                }
            }
        });
    });
}